import React from 'react';
import "./style.css"
import { Post } from '../../../types';
import { BUCKET_PACOCA_URL } from '../../../global-components/src/utils/vars';
import { useNavigate } from 'react-router-dom';
import { getImageUser, getImageUserNotFound, isEveryOnline } from '../../../global-components/src/utils/auth';
import { getImageNotFound, getImagePathBucketPacoca } from '../../../global-components/src/utils/utils';
import { canAnimateProfilePhoto, FreezeGif } from '../../../pages/Account/freeze-gif';

interface ImgProfilePostProps {
    post: Post; // aqui você define que post é do tipo Post
}
const ImgProfilePost: React.FC<ImgProfilePostProps> = ({ post }) => {
    var img = post?.user?.img_account ?  getImageUser(post?.user?.img_account, undefined, post?.user?.name) : getImageUserNotFound(post?.user?.name);
    img = post?.group ?  getImagePathBucketPacoca(post?.group?.img, getImageNotFound(post?.group?.name ?? undefined)) : img;
    var imgUser = post?.user?.img_account ?  getImageUser(post?.user?.img_account, undefined, post?.user?.name) : getImageUserNotFound(post?.user?.name);
    const navigate = useNavigate();

    return (
        <div className="col-2 col-img-account-post img-list-chat img-account-search" style={{cursor: "pointer", position: "relative"}}>
        {/* <div className="col-2 col-img-account-post img-list-chat img-account-search img-account-post" style={{cursor: "pointer"}}> */}
            {/* imagem do usuario ou da comunidade */}
            {post?.group_id ? (
                <img onClick={() => navigate(`/@${post?.user.user_name}`, { state: { user: post?.user } }) } className="img-account-community user-select-none img-account-post" src={img} alt="" onError={(e) => { e.currentTarget.src = "/img/img-placeholder.jpg"; }} />
            ) : (
                <FreezeGif
                    onClick={() => navigate(`/@${post?.user.user_name}`, { state: { user: post?.user } })}
                    className="user-select-none img-account-post"
                    src={img}
                    fallbackSrc={getImageUserNotFound(post?.user?.name)}
                    shouldAnimate={canAnimateProfilePhoto(post?.user?.stamps)}
                    alt=""
                    onError={(e) => { e.currentTarget.src = getImageUserNotFound(post?.user?.name); }}
                />
            )}
            
            {(post?.user?.is_online || isEveryOnline(post?.user?.id)) && (
                <div className={post?.group_id ? "active-user-post-community" : "active-user-post"}/>
            )}

            {/* se for de comunidade, mostra imagem do usuario menor */}
            {post?.group_id ? (
                <FreezeGif
                    onClick={() => navigate(`/@${post?.user.user_name}`, { state: { user: post?.user } })}
                    className="user-select-none img-community-post"
                    src={imgUser}
                    fallbackSrc={getImageUserNotFound(post?.user?.name)}
                    shouldAnimate={canAnimateProfilePhoto(post?.user?.stamps)}
                    alt=""
                    onError={(e) => { e.currentTarget.src = getImageUserNotFound(post?.user?.name); }}
                />
            ) : null}
                
        </div>
    );
};

export default ImgProfilePost;
